import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CuttingPanelListService, OutlineEditorOptions, PostformingSideEnum } from 'cloud-shared-lib';
import * as _ from 'lodash';

import { Observable, tap, timer } from 'rxjs';
import { ManyButtInColorBottomSheetComponent } from '../../../../components/many-butt-in-color-bottom-sheet/many-butt-in-color-bottom-sheet.component';
import { SvgWorkspaceComponent } from '../../../../components/svg-workspace/svg-workspace.component';
import { CuttingButt } from '../../../../models/cutting/cutting-butt.model';
import { CuttingMaterial } from '../../../../models/cutting/cutting-material.model';
import { CuttingPanel } from '../../../../models/cutting/cutting-panel.model';
import { CuttingButtFormService } from '../../../../services/cutting-butt-form.service';
import {
  MaterialBaseButtsDialogComponent,
  MaterialBaseEdgeDialogData,
} from '../../../material-base-butts-dialog/material-base-butts-dialog.component';
import { Butts } from '../panel-outline-editor-dialog.component';
import { ButtForAllSidesBottomSheetComponent } from './butt-for-all-sides-bottom-sheet/butt-for-all-sides-bottom-sheet.component';

export enum ButtTypeEnum {
  top,
  bottom,
  left,
  right,
}

@Component({
  selector: 'csl-butt-form',
  templateUrl: './butt-form.component.html',
  styleUrls: ['./butt-form.component.scss'],
})
export class ButtFormComponent implements OnInit {
  thisByttTypeEnum = ButtTypeEnum;
  buttsInColorThicknesses: Set<number> = new Set();
  buttsInColorList: CuttingButt[] = [];
  materialBaseDialogRef: MatDialogRef<MaterialBaseButtsDialogComponent>;
  outlineOptions: OutlineEditorOptions;
  private _orignPanel: CuttingPanel;

  render$: Observable<number>;

  @Input() editable = true;
  @Input() mainMaterial: CuttingMaterial;
  @Input() panel: CuttingPanel;
  @Input() postforming: PostformingSideEnum = PostformingSideEnum.None;

  @Input() matInMatBaseId = 0;

  @Output() formChanged: EventEmitter<Butts> = new EventEmitter();

  @ViewChild('svgWorkspace', { static: true }) svgWorkspace: SvgWorkspaceComponent;

  get fullPanelThickness(): number {
    if (this.panel.panelOutline.faceBanding.length > 0) {
      return (
        this.mainMaterial.thickness +
        this.panel.panelOutline.faceBanding.map(b => b.material.thickness).reduce((a, v) => a + v)
      );
    } else {
      return this.mainMaterial.thickness;
    }
  }

  get showQuantityInStock(): boolean {
    return this.cuttingPanelListService.onCuttingOptionsChanged.value.showQuantityInStock;
  }

  constructor(
    private cuttingPanelListService: CuttingPanelListService,
    private setButtDialogService: CuttingButtFormService,
    private bottomSheet: MatBottomSheet,
    public dialog: MatDialog
  ) {
    this.cuttingPanelListService.onCuttingOptionsChanged.subscribe(response => {
      this.outlineOptions = response.outlineEditorOptions;
    });
  }

  ngOnInit(): void {
    if (this.editable) {
      this.setButtDialogService
        .getMatchedButtsForClient(this.matInMatBaseId, this.fullPanelThickness)
        .then((response: CuttingButt[]) => {
          this.buttsInColorThicknesses.clear();
          this.buttsInColorList = response;

          this.buttsInColorList.forEach((b: CuttingButt) => {
            this.panel.l1 = this.buttEquals(b, this.panel.l1) ? b : this.panel.l1;
            this.panel.l2 = this.buttEquals(b, this.panel.l2) ? b : this.panel.l2;
            this.panel.w1 = this.buttEquals(b, this.panel.w1) ? b : this.panel.w1;
            this.panel.w2 = this.buttEquals(b, this.panel.w2) ? b : this.panel.w2;

            this.buttsInColorThicknesses.add(b.thickness);
          });
        });
    }

    /* TODO: Т к раньше это делалось в ngAfterViewChecked, это очень перегружало основной поток и вызывало циклические рендеры,
     * чтобы ничего не поломать и снизить нагрузку добавлен этот костыль,
     * но перерисовку все равно необходимо переделать, чтобы схема перерисовывалась только при реальных изменениях в панели
     */
    this.render$ = timer(0, 1000).pipe(
      tap(() => {
        this.redraw();
      })
    );
  }

  redraw(): void {
    this.svgWorkspace.draw(this.panel);
  }

  private buttEquals(one: CuttingButt, two: CuttingButt): boolean {
    if (one === two) {
      return true;
    }

    if (!(one instanceof Object) || !(two instanceof Object)) {
      return false;
    }

    for (const p in one) {
      if (!one.hasOwnProperty(p)) {
        continue;
      }

      if (!two.hasOwnProperty(p)) {
        return false;
      }

      if (one[p] === two[p]) {
        continue;
      }

      if (typeof one[p] !== 'object') {
        return false;
      }

      if (!this.buttEquals(one[p], two[p])) {
        return false;
      }
    }

    for (const p in two) {
      if (two.hasOwnProperty(p) && !one.hasOwnProperty(p)) {
        return false;
      }
    }

    return true;
  }

  async setButtFromBase(buttType: ButtTypeEnum): Promise<void> {
    const result = await this.openMaterialBaseDialog();

    if (result) {
      switch (buttType) {
        case ButtTypeEnum.top:
          this.panel.l1 = result;
          break;

        case ButtTypeEnum.bottom:
          this.panel.l2 = result;
          break;

        case ButtTypeEnum.left:
          this.panel.w1 = result;
          break;

        case ButtTypeEnum.right:
          this.panel.w2 = result;
          break;
      }

      this.setButtToBesideAngles(result, buttType);

      this.formChanged.next({ top: this.panel.l1, bottom: this.panel.l2, left: this.panel.w1, right: this.panel.w2 });
    }
  }

  openMaterialBaseDialog(): Promise<CuttingButt | undefined> {
    this.materialBaseDialogRef = this.dialog.open(MaterialBaseButtsDialogComponent, {
      panelClass: 'material-base-butt-list-dialog',
      disableClose: false,
      width: '1000px',
      data: {
        panelThickness: this.fullPanelThickness,
        showQuantityInStock: this.showQuantityInStock,
      } as MaterialBaseEdgeDialogData,
    });

    return new Promise((resolve, reject) => {
      this.materialBaseDialogRef.afterClosed().subscribe((result: CuttingButt | undefined) => {
        this.materialBaseDialogRef = null;
        resolve(result);
      }, reject);
    });
  }

  deleteButt(buttType: ButtTypeEnum): void {
    switch (buttType) {
      case ButtTypeEnum.top:
        this.panel.l1 = undefined;
        break;

      case ButtTypeEnum.bottom:
        this.panel.l2 = undefined;
        break;

      case ButtTypeEnum.left:
        this.panel.w1 = undefined;
        break;

      case ButtTypeEnum.right:
        this.panel.w2 = undefined;
        break;
    }

    this.formChanged.next({ top: this.panel.l1, bottom: this.panel.l2, left: this.panel.w1, right: this.panel.w2 });
  }

  async setButt(event: MatButtonToggleChange, buttType: ButtTypeEnum): Promise<void> {
    const buttsForThickness: CuttingButt[] = this.buttsInColorList.filter(b => +b.thickness === +event.value);

    let selectedButt;

    if (buttsForThickness.length > 1) {
      selectedButt = await this.openBottomSheet(buttsForThickness);
    } else {
      selectedButt = buttsForThickness[0];
    }

    if (selectedButt) {
      switch (buttType) {
        case ButtTypeEnum.top:
          this.panel.l1 = selectedButt;
          break;
        case ButtTypeEnum.bottom:
          this.panel.l2 = selectedButt;
          break;
        case ButtTypeEnum.left:
          this.panel.w1 = selectedButt;
          break;
        case ButtTypeEnum.right:
          this.panel.w2 = selectedButt;
          break;
      }

      this.setButtToBesideAngles(selectedButt, buttType);

      this.formChanged.next({ top: this.panel.l1, bottom: this.panel.l2, left: this.panel.w1, right: this.panel.w2 });
    } else {
      event.source.buttonToggleGroup.value = undefined;
    }
  }

  setButtToBesideAngles(butt: CuttingButt, buttType: ButtTypeEnum): boolean {
    if (!butt) {
      return false;
    }

    switch (buttType) {
      case ButtTypeEnum.top:
        if (!this.panel.panelOutline.topLeft.butt) {
          this.panel.panelOutline.topLeft.butt = _.cloneDeep(butt);
        }

        if (!this.panel.panelOutline.topRight.butt) {
          this.panel.panelOutline.topRight.butt = _.cloneDeep(butt);
        }

        break;
      case ButtTypeEnum.bottom:
        if (!this.panel.panelOutline.bottomLeft.butt) {
          this.panel.panelOutline.bottomLeft.butt = _.cloneDeep(butt);
        }

        if (!this.panel.panelOutline.bottomRight.butt) {
          this.panel.panelOutline.bottomRight.butt = _.cloneDeep(butt);
        }

        break;
      case ButtTypeEnum.left:
        if (!this.panel.panelOutline.topLeft.butt) {
          this.panel.panelOutline.topLeft.butt = _.cloneDeep(butt);
        }

        if (!this.panel.panelOutline.bottomLeft.butt) {
          this.panel.panelOutline.bottomLeft.butt = _.cloneDeep(butt);
        }

        break;
      case ButtTypeEnum.right:
        if (!this.panel.panelOutline.topRight.butt) {
          this.panel.panelOutline.topRight.butt = _.cloneDeep(butt);
        }

        if (!this.panel.panelOutline.bottomRight.butt) {
          this.panel.panelOutline.bottomRight.butt = _.cloneDeep(butt);
        }

        break;
    }

    this.formChanged.next({ top: this.panel.l1, bottom: this.panel.l2, left: this.panel.w1, right: this.panel.w2 });
  }

  openBottomSheet(buttsForSelect: CuttingButt[]): Promise<CuttingButt | undefined> {
    let bottomSheetRef = this.bottomSheet.open(ManyButtInColorBottomSheetComponent, {
      ariaLabel: $localize`Выбор облицовки в цвет`,
      disableClose: false,
      data: buttsForSelect,
    });

    return new Promise((resolve, reject) => {
      bottomSheetRef.afterDismissed().subscribe((res: CuttingButt | undefined) => {
        resolve(res);

        bottomSheetRef = null;
      });
    });
  }

  async setButtForAllSides(buttsForSelect: CuttingButt[]): Promise<void> {
    let butt: CuttingButt;

    if (buttsForSelect && buttsForSelect.length > 0) {
      butt = await this.openButtForAllSidesBottomSheet(buttsForSelect);
    } else {
      butt = await this.openMaterialBaseDialog();
    }

    if (butt) {
      this.panel.w1 = butt;
      this.panel.w2 = butt;

      if (this.postforming !== PostformingSideEnum.TopAndBottom) {
        this.panel.l1 = butt;
      }

      if (this.postforming !== PostformingSideEnum.Bottom) {
        this.panel.l2 = butt;
      }

      if (
        this.outlineOptions.angles.insideCutting.restrictions.addButtToCutting ||
        this.outlineOptions.angles.insideCuttingWithAngle.restrictions.addButtToCutting
      ) {
        this.panel.panelOutline.topRight.butt = butt;
        this.panel.panelOutline.topLeft.butt = butt;
        this.panel.panelOutline.bottomRight.butt = butt;
        this.panel.panelOutline.bottomLeft.butt = butt;
      }

      this.formChanged.next({ top: this.panel.l1, bottom: this.panel.l2, left: this.panel.w1, right: this.panel.w2 });
    }
  }

  openButtForAllSidesBottomSheet(buttsForSelect: CuttingButt[]): Promise<CuttingButt | undefined> {
    let bottomSheetRef = this.bottomSheet.open(ButtForAllSidesBottomSheetComponent, {
      ariaLabel: 'CuttingButt selection in color',
      disableClose: false,
      data: { butts: buttsForSelect, panelThickness: this.fullPanelThickness },
    });

    return new Promise((resolve, reject) => {
      bottomSheetRef.afterDismissed().subscribe((res: CuttingButt | undefined) => {
        resolve(res);

        bottomSheetRef = null;
      });
    });
  }
}
